"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRanges = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
exports.DateRanges = {
    TODAY: {
        title: 'Today',
        from: () => (0, moment_timezone_1.default)().tz('UTC').startOf('day'),
        to: from => from.clone().add(1, 'days').subtract(1, 'millisecond'),
        interval: '<D/>D',
    },
    YESTERDAY: {
        title: 'Yesterday',
        from: () => (0, moment_timezone_1.default)().tz('UTC').subtract(1, 'day').startOf('day'),
        to: from => from.clone().add(1, 'days').subtract(1, 'millisecond'),
        interval: '<P1D/>D',
    },
    THISWEEK: {
        title: 'This week',
        from: () => (0, moment_timezone_1.default)().tz('UTC').startOf('week'),
        to: from => from.clone().add(7, 'days').subtract(1, 'millisecond'),
        interval: '<W/>W',
    },
    LASTWEEK: {
        title: 'Last week',
        from: () => (0, moment_timezone_1.default)().tz('UTC').subtract(7, 'days').startOf('week'),
        to: from => from.clone().add(7, 'days').subtract(1, 'millisecond'),
        interval: 'P1W/<W',
    },
    THISMONTH: {
        title: 'This month',
        from: () => (0, moment_timezone_1.default)().tz('UTC').startOf('month'),
        to: from => from.clone().add(1, 'month').subtract(1, 'millisecond'),
        interval: '<M/>M',
    },
    LASTMONTH: {
        title: 'Last month',
        from: () => (0, moment_timezone_1.default)().tz('UTC').subtract(1, 'month').startOf('month'),
        to: from => from.clone().add(1, 'month').subtract(1, 'millisecond'),
        interval: 'P1M/<M',
    },
    LAST7DAYS: {
        title: 'Last 7 days',
        from: () => (0, moment_timezone_1.default)().tz('UTC').subtract(6, 'days').startOf('day'),
        to: from => from.clone().add(7, 'days').subtract(1, 'millisecond'),
        interval: 'P7D/>D',
    },
    LAST14DAYS: {
        title: 'Last 14 days',
        from: () => (0, moment_timezone_1.default)().tz('UTC').subtract(13, 'days').startOf('day'),
        to: from => from.clone().add(14, 'days').subtract(1, 'millisecond'),
        interval: 'P14D/>D',
    },
    LAST28DAYS: {
        title: 'Last 28 days',
        from: () => (0, moment_timezone_1.default)().tz('UTC').subtract(27, 'days').startOf('day'),
        to: from => from.clone().add(28, 'days').subtract(1, 'millisecond'),
        interval: 'P28D/>D',
    },
};
exports.default = exports.DateRanges;
